var _rect, _circle, _circle2, _circle3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRerordingKeyStoped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 312,
    viewBox: "0 0 312 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 106,
    rx: 53,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 210 211)",
    fill: "url(#paint0_radial_0_1)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 156,
    cy: 156,
    r: 155,
    stroke: "#F2EEED",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 155.999,
    cy: 156,
    r: 124.19,
    stroke: "#F2EEED",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 155.999,
    cy: 156,
    r: 83.9209,
    stroke: "#F2EEED",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.172 145.672C153.922 144.921 154.939 144.5 156 144.5C157.061 144.5 158.078 144.921 158.828 145.672C159.579 146.422 160 147.439 160 148.5V156.5C160 157.561 159.579 158.578 158.828 159.328C158.078 160.079 157.061 160.5 156 160.5C154.939 160.5 153.922 160.079 153.172 159.328C152.421 158.578 152 157.561 152 156.5V148.5C152 147.439 152.421 146.422 153.172 145.672ZM156 146.5C155.47 146.5 154.961 146.711 154.586 147.086C154.211 147.461 154 147.97 154 148.5V156.5C154 157.03 154.211 157.539 154.586 157.914C154.961 158.289 155.47 158.5 156 158.5C156.53 158.5 157.039 158.289 157.414 157.914C157.789 157.539 158 157.03 158 156.5V148.5C158 147.97 157.789 147.461 157.414 147.086C157.039 146.711 156.53 146.5 156 146.5Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149 153.5C149.552 153.5 150 153.948 150 154.5V156.5C150 158.091 150.632 159.617 151.757 160.743C152.883 161.868 154.409 162.5 156 162.5C157.591 162.5 159.117 161.868 160.243 160.743C161.368 159.617 162 158.091 162 156.5V154.5C162 153.948 162.448 153.5 163 153.5C163.552 153.5 164 153.948 164 154.5V156.5C164 158.622 163.157 160.657 161.657 162.157C160.157 163.657 158.122 164.5 156 164.5C153.878 164.5 151.843 163.657 150.343 162.157C148.843 160.657 148 158.622 148 156.5V154.5C148 153.948 148.448 153.5 149 153.5Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156 162.5C156.552 162.5 157 162.948 157 163.5V167.5C157 168.052 156.552 168.5 156 168.5C155.448 168.5 155 168.052 155 167.5V163.5C155 162.948 155.448 162.5 156 162.5Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151 167.5C151 166.948 151.448 166.5 152 166.5H160C160.552 166.5 161 166.948 161 167.5C161 168.052 160.552 168.5 160 168.5H152C151.448 168.5 151 168.052 151 167.5Z",
    fill: "#FCFCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.701 -17.9821) rotate(135.167) scale(175.851 174.583)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FF9F53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(144 144.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRerordingKeyStoped);
export default __webpack_public_path__ + "static/media/rerording-key-stoped.bd87bb47b9cb942685f70ed9b3dada68.svg";
export { ForwardRef as ReactComponent };